module.exports = __webpack_public_path__ + "static/img/oca-report.a4fa3ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/oca-report.jpg
// module id = F/RA
// module chunks = 0